/*
 * Automatically generated by codegen/smith.ts.
 * Do not edit this file or add other files to this directory.
 */
import { seamApiLtsVersion } from '../../../../../lib/lts-version.js';
import { getAuthHeadersForClientSessionToken, warnOnInsecureuserIdentifierKey, } from '../../../../../lib/seam/connect/auth.js';
import { createClient } from '../../../../../lib/seam/connect/client.js';
import { isSeamHttpOptionsWithApiKey, isSeamHttpOptionsWithClient, isSeamHttpOptionsWithClientSessionToken, isSeamHttpOptionsWithConsoleSessionToken, isSeamHttpOptionsWithPersonalAccessToken, SeamHttpInvalidOptionsError, } from '../../../../../lib/seam/connect/options.js';
import { limitToSeamHttpRequestOptions, parseOptions, } from '../../../../../lib/seam/connect/parse-options.js';
import { SeamHttpClientSessions } from '../../../../../lib/seam/connect/routes/client-sessions/index.js';
import { SeamHttpRequest } from '../../../../../lib/seam/connect/seam-http-request.js';
import { SeamPaginator } from '../../../../../lib/seam/connect/seam-paginator.js';
import { SeamHttpThermostatsDailyPrograms } from './daily-programs/index.js';
import { SeamHttpThermostatsSchedules } from './schedules/index.js';
import { SeamHttpThermostatsSimulate } from './simulate/index.js';
export class SeamHttpThermostats {
    client;
    defaults;
    ltsVersion = seamApiLtsVersion;
    static ltsVersion = seamApiLtsVersion;
    constructor(apiKeyOrOptions = {}) {
        const options = parseOptions(apiKeyOrOptions);
        this.client = 'client' in options ? options.client : createClient(options);
        this.defaults = limitToSeamHttpRequestOptions(options);
    }
    static fromClient(client, options = {}) {
        const constructorOptions = { ...options, client };
        if (!isSeamHttpOptionsWithClient(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing client');
        }
        return new SeamHttpThermostats(constructorOptions);
    }
    static fromApiKey(apiKey, options = {}) {
        const constructorOptions = { ...options, apiKey };
        if (!isSeamHttpOptionsWithApiKey(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing apiKey');
        }
        return new SeamHttpThermostats(constructorOptions);
    }
    static fromClientSessionToken(clientSessionToken, options = {}) {
        const constructorOptions = { ...options, clientSessionToken };
        if (!isSeamHttpOptionsWithClientSessionToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing clientSessionToken');
        }
        return new SeamHttpThermostats(constructorOptions);
    }
    static async fromPublishableKey(publishableKey, userIdentifierKey, options = {}) {
        warnOnInsecureuserIdentifierKey(userIdentifierKey);
        const clientOptions = parseOptions({ ...options, publishableKey });
        if (isSeamHttpOptionsWithClient(clientOptions)) {
            throw new SeamHttpInvalidOptionsError('The client option cannot be used with SeamHttpThermostats.fromPublishableKey');
        }
        const client = createClient(clientOptions);
        const clientSessions = SeamHttpClientSessions.fromClient(client);
        const { token } = await clientSessions.getOrCreate({
            user_identifier_key: userIdentifierKey,
        });
        return SeamHttpThermostats.fromClientSessionToken(token, options);
    }
    static fromConsoleSessionToken(consoleSessionToken, workspaceId, options = {}) {
        const constructorOptions = { ...options, consoleSessionToken, workspaceId };
        if (!isSeamHttpOptionsWithConsoleSessionToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing consoleSessionToken or workspaceId');
        }
        return new SeamHttpThermostats(constructorOptions);
    }
    static fromPersonalAccessToken(personalAccessToken, workspaceId, options = {}) {
        const constructorOptions = { ...options, personalAccessToken, workspaceId };
        if (!isSeamHttpOptionsWithPersonalAccessToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing personalAccessToken or workspaceId');
        }
        return new SeamHttpThermostats(constructorOptions);
    }
    createPaginator(request) {
        return new SeamPaginator(this, request);
    }
    async updateClientSessionToken(clientSessionToken) {
        const { headers } = this.client.defaults;
        const authHeaders = getAuthHeadersForClientSessionToken({
            clientSessionToken,
        });
        for (const key of Object.keys(authHeaders)) {
            if (headers[key] == null) {
                throw new Error('Cannot update a clientSessionToken on a client created without a clientSessionToken');
            }
        }
        this.client.defaults.headers = { ...headers, ...authHeaders };
        const clientSessions = SeamHttpClientSessions.fromClient(this.client);
        await clientSessions.get();
    }
    get dailyPrograms() {
        return SeamHttpThermostatsDailyPrograms.fromClient(this.client, this.defaults);
    }
    get schedules() {
        return SeamHttpThermostatsSchedules.fromClient(this.client, this.defaults);
    }
    get simulate() {
        return SeamHttpThermostatsSimulate.fromClient(this.client, this.defaults);
    }
    activateClimatePreset(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/activate_climate_preset',
            method: 'POST',
            body: parameters,
            responseKey: 'action_attempt',
            options,
        });
    }
    cool(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/cool',
            method: 'POST',
            body: parameters,
            responseKey: 'action_attempt',
            options,
        });
    }
    createClimatePreset(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/create_climate_preset',
            method: 'POST',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    deleteClimatePreset(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/delete_climate_preset',
            method: 'POST',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    get(parameters, options = {}) {
        if (!this.defaults.isUndocumentedApiEnabled) {
            throw new Error('Cannot use undocumented API without isUndocumentedApiEnabled');
        }
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/get',
            method: 'POST',
            body: parameters,
            responseKey: 'thermostat',
            options,
        });
    }
    heat(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/heat',
            method: 'POST',
            body: parameters,
            responseKey: 'action_attempt',
            options,
        });
    }
    heatCool(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/heat_cool',
            method: 'POST',
            body: parameters,
            responseKey: 'action_attempt',
            options,
        });
    }
    list(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/list',
            method: 'POST',
            body: parameters,
            responseKey: 'devices',
            options,
        });
    }
    off(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/off',
            method: 'POST',
            body: parameters,
            responseKey: 'action_attempt',
            options,
        });
    }
    setFallbackClimatePreset(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/set_fallback_climate_preset',
            method: 'POST',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    setFanMode(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/set_fan_mode',
            method: 'POST',
            body: parameters,
            responseKey: 'action_attempt',
            options,
        });
    }
    setHvacMode(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/set_hvac_mode',
            method: 'POST',
            body: parameters,
            responseKey: 'action_attempt',
            options,
        });
    }
    setTemperatureThreshold(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/set_temperature_threshold',
            method: 'PATCH',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    updateClimatePreset(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/update_climate_preset',
            method: 'PATCH',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    updateWeeklyProgram(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/thermostats/update_weekly_program',
            method: 'POST',
            body: parameters,
            responseKey: 'action_attempt',
            options,
        });
    }
}
//# sourceMappingURL=thermostats.js.map